export const LOOK_AND_BOOK_SERVICE = 'funnel/api/query/stats';

export const LABI_META = 'labiQueryMeta';
export const LABI_QUERY = 'labiQuery';
